import { render, staticRenderFns } from "./unionStaffAuthEdit.vue?vue&type=template&id=4f88d5e0&scoped=true&"
import script from "./unionStaffAuthEdit.vue?vue&type=script&lang=js&"
export * from "./unionStaffAuthEdit.vue?vue&type=script&lang=js&"
import style0 from "./unionStaffAuthEdit.vue?vue&type=style&index=0&id=4f88d5e0&lang=less&scoped=true&"
import style1 from "./unionStaffAuthEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88d5e0",
  null
  
)

component.options.__file = "unionStaffAuthEdit.vue"
export default component.exports